<template>
	<div id="ag-grid-demo">
		<vx-card :title="taskListName">

			<!-- TABLE ACTION ROW -->
			<div class="flex flex-wrap justify-between items-center">

				<!-- ITEMS PER PAGE -->
				<div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

					<vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
						<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
							<span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ displayTaskList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : displayTaskList.length }} of {{ displayTaskList.length }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>

						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<vs-dropdown-menu>

							<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
								<span>50</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
								<span>100</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
								<span>150</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(200)">
								<span>200</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(300)">
								<span>300</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(500)">
								<span>500</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>

				</div>


				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
					<vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
					<vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
				</div>
			</div>

			<ag-grid-vue
					ref="agGridTable"
					:gridOptions="gridOptions"
					class="ag-theme-material w-100 my-4 ag-grid-table"
					:columnDefs="columnDefs"
					:defaultColDef="defaultColDef"
					:rowData="displayTaskList"
					rowSelection="multiple"
					colResizeDefault="shift"
					:animateRows="true"
					domLayout="autoHeight"
					:floatingFilter="true"
					:pagination="true"
					:paginationPageSize="paginationPageSize"
					:suppressPaginationPanel="true">
			</ag-grid-vue>
			<vs-pagination
					:total="totalPages"
					:max="maxPageNumbers"
					v-model="currentPage" />

		</vx-card>

		<vs-popup :title="$t('Description')" :active.sync="taskDescriptionPromptOpen">
			<p class="pl-6" style="white-space: pre-wrap">{{taskDescription}}</p>
		</vs-popup>
	</div>
</template>
<script>

	import { AgGridVue } from "ag-grid-vue"
	import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
	import TimeRenderer from "./Task/TimeRenderer";
	import StatusRenderer from "./Task/StatusRenderer";

	export default {
		components: {
			AgGridVue,
			TimeRenderer,
			StatusRenderer,
		},
		props: {
			taskList: {
				type: Number,
				required: true
			},
		},
		data() {
			return {

				taskDescription: '',
				taskDescriptionPromptOpen: false,

				searchQuery: '',
				gridOptions: {
					suppressRowClickSelection: true,
					onCellClicked: (e) => {
						if (e.column.colId === 'title') {
							this.$vs.loading();
							const thisIns = this;
							this.$http.get('/api/v1/tasks/task/' + e.node.data.id)
									.then(function (response) {
										thisIns.$vs.loading.close();
										if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
												|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
											window.location.href = "/pdf/data/" + response.data;
										}else{
											window.open("/pdf/data/" + response.data, "_blank");
										}
									})
									.catch(function (error) {
										thisIns.$vs.loading.close();
										thisIns.$vs.notify({
											title:'Error',
											position:'top-right',
											text: error,
											color:'danger',
											iconPack: 'feather',
											icon:'icon-alert-circle'})
									});

						}
					},
					onRowDataChanged: () => {
						this.$nextTick(() => {
							this.gridColumnApi.autoSizeColumns(['company_task_id', 'title', 'branch_office', 'status', 'company_user', 'added_time', 'deadline', 'client_company_contact']);
							if(this.columnsWidth < this.tableWidth){
								this.gridApi.sizeColumnsToFit()
							}
						});
					}
				},
				maxPageNumbers: 7,
				gridApi: null,
				gridColumnApi: null,
				defaultColDef: {
					sortable: true,
					editable: false,
					resizable: true,
					suppressMenu: true
				},
				columnDefs: [
					{
						headerName: "ID",
						field: 'company_task_id',
						filter: true,
						width: 50
					},
					{
						headerName: this.$t("TaskTitle"),
						field: 'title',
						filter: true,
					},
					{
						headerName: this.$t("BranchOffice"),
						field: 'branch_office',
						filter: true,
					},
					{
						headerName: this.$t("Status"),
						field: 'status',
						filter: true,
						valueGetter: this.statusValueGetter,
						cellRendererFramework: StatusRenderer,
					},
					{
						headerName: this.$t("AssignedUser"),
						field: 'company_user',
						filter: true,
					},
					{
						headerName: this.$t("Added"),
						field: 'added_time',
						filter: true,
						width: 150,
						cellRendererFramework: TimeRenderer,
					},
					{
						headerName: this.$t("Deadline"),
						field: 'deadline',
						filter: true,
						width: 150,
						cellRendererFramework: TimeRenderer,
					},
					{
						headerName: this.$t("Contact"),
						field: 'client_company_contact',
						filter: true,
					},
				],
				tasks: [],

			}
		},
		computed: {
			taskListName() {
				switch (this.taskList) {
					case 0:
						return this.$t("TasksAll");
					case 1:
						return this.$t("TasksInConfirmation");
					case 2:
						return this.$t("TasksFinished");
					default:
						return ""

				}
			},
			displayTaskList() {
				return this.tasks
			},
			columnsWidth() {
				let total = 0;
				let state = this.gridColumnApi.getColumnState();
				if(state){
					for(let x = 0; x < state.length; x++){
						total += state[x].width
					}
				}

				return total;
			},
			tableWidth() {
				return this.gridApi.gridPanel.eBodyViewport.clientWidth;
			},
			paginationPageSize() {
				if(this.gridApi) return this.gridApi.paginationGetPageSize()
				else return 50
			},
			totalPages() {
				if(this.gridApi) return this.gridApi.paginationGetTotalPages()
				else return 0
			},
			currentPage: {
				get() {
					if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
					else return 1
				},
				set(val) {
					if(this.gridApi){
						this.gridApi.paginationGoToPage(val - 1)
					}

				}
			},
		},
		watch: {
			taskList: function () {
				this.updateTasks();
			},
		},
		methods: {
			resizeColumns(){
				this.gridColumnApi.autoSizeColumns(['company_task_id', 'title', 'branch_office', 'status', 'company_user', 'added_time', 'deadline', 'client_company_contact']);
				if(this.columnsWidth < this.tableWidth){
					this.gridApi.sizeColumnsToFit()
				}
			},
			updateSearchQuery(val) {
				this.gridApi.setQuickFilter(val)
			},
			updateTasks() {

				let request = "";
				switch (this.taskList) {
					case 0:
						request = "open";
						break;
					case 1:
						request = "inConfirmation";
						break;
					case 2:
						request = "finished";
						break;
					default:
						request = "open";

				}

				const thisIns = this;
				thisIns.tasks = [];

				this.$http.get('/api/v1/tasks/' + request)
						.then(function (response) {
							thisIns.tasks = response.data;
							thisIns.$nextTick(() => {
								thisIns.resizeColumns();
							});
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			statusValueGetter(param){
				switch (param.data.status) {
					case 0:
						return this.$t("Unassigned");
					case 1:
						return this.$t("Open");
					case 2:
						return this.$t("InProgress");
					case 3:
						return this.$t("Waiting");
					case 4:
						return this.$t("SentForConfirmation");
					case 5:
						return this.$t("Confirmed");
					case 6:
						return this.$t("Invoiced");
					default:
						return ""

				}
			}
		},
		mounted() {
			this.gridApi = this.gridOptions.api;
			this.gridColumnApi = this.gridOptions.columnApi;
			this.updateTasks();

		},
	}

</script>
